import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../../services/utilityFunctions';
import Modal from '../../../../commonComponents/modal/Modal';
import ModalHeader from '../../../../commonComponents/modal/ModalHeader';
import ModalFooter from '../../../../commonComponents/modal/ModalFooter';
import translate from '../../../../commonComponents/translate';
import withCSRF from '../../../../commonComponents/withCSRF';

function RemoveModal({ t, title, contentText, index, onRemove, onClose }) {
  const handleCancel = () => onClose(false);

  return (
    <Modal onClose={handleCancel}>
      <div className="modal-dialog">
        <div className="modal-content">
          <ModalHeader title={title} onClose={handleCancel} />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="portlet-body form">
                  <p style={{ paddingLeft: '20px' }}>{contentText}</p>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={() => {
              onRemove(index);
            }}
            onCancel={handleCancel}
            saveText={t('confirm')}
            cancelText={t('cancel')}
            saveIsLoader
          />
        </div>
      </div>
    </Modal>
  );
}

RemoveModal.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  contentText: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(
  translate,
  withCSRF,
)(RemoveModal);
